import * as React from 'react';
import clsx from 'clsx';

import * as styles from './FiltersContentWrapper.css';

interface IFiltersContentWrapperProps {
  children: React.ReactNode;
  isVisible: boolean;
}

export const FiltersContentWrapper: React.FC<IFiltersContentWrapperProps> = ({ children, isVisible }) => {
  return (
    <div className={clsx(styles['outer'], isVisible ? styles['visible'] : styles['hidden'])}>
      <div className={styles['inner']}>{children}</div>
    </div>
  );
};
